{
  "name": "museum-vlaardingen-cms",
  "version": "1.0.3",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "21.2.14",
    "@angular/common": "^21.2.17",
    "@angular/compiler": "^21.2.17",
    "@angular/core": "^21.2.17",
    "@angular/forms": "^21.2.17",
    "@angular/material": "21.2.14",
    "@angular/platform-browser": "^21.2.17",
    "@angular/router": "^21.2.17",
    "@angular/youtube-player": "^21.2.14",
    "@hugerte/hugerte-angular": "^1.0.3",
    "@mrfrontend/angular-itcss-tools": "^0.0.2",
    "@mrfrontend/itcss-tools": "^0.0.15",
    "hugerte": "^1.0.9",
    "keycloak-angular": "^20.0.0",
    "keycloak-js": "^26.2.0",
    "ol": "^10.6.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "22.0.0",
    "@angular/build": "^21.2.15",
    "@angular/cli": "^21.2.15",
    "@angular/compiler-cli": "^21.2.17",
    "@eslint/js": "^9.35.0",
    "@types/jasmine": "~5.1.0",
    "@types/ol": "^7.0.0",
    "angular-eslint": "22.0.0",
    "eslint": "^9.35.0",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.2",
    "typescript-eslint": "8.40.0"
  }
}
